<template>
    <div class="col">

        <div id="main"
             class="col-main">

            <section class="news-container">
                <div class="news-article row no-gutters row-main justify-content-center">
                    <div class="col-12 col-lg-10 bg-white">

                        <div class="row no-gutters justify-content-center">

                            <div class="news-article-header col-12 col-lg-9">
                                <h2 class="news-title">{{news.title}}</h2>
                                <h6 class="news-date">
                                    <i class="material-icons icon-4">schedule</i> <span>{{news.readableDate}}</span>
                                </h6>
                            </div>

                            <div class="news-article-body col-12 col-lg-9" v-html="news.article">
                                <!-- Text -->
                                {{news.article}}
                            </div>

                        </div>


                    </div>
                </div>
            </section>

        </div>

    </div>
</template>
<script>
    import {fetchNewsByID} from "@/services/api";

    export default {
        data() {
            return {
                id: null,
                news: {}
            }
        },
        created() {
            this.id = this.$route.query.id;
            this.fetchNews();
        },
        methods: {
            fetchNews() {
                fetchNewsByID(this.id)
                    .then(response => {
                        this.news = response;

                        let day = new Date(this.news.publish_date).toLocaleString('default', {day: '2-digit'});
                        let month = new Date(this.news.publish_date).toLocaleString('default', {month: 'long'});
                        let year = new Date(this.news.publish_date).getFullYear();
                        this.news.readableDate = day + ' ' + month + ' ' + year;
                    })
            }
        }
    }
</script>